"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvisibleAttachment = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var FileUpload_1 = require("./FileUpload");
var Progress_1 = require("./Progress");
var InvisibleAttachment = function (_a) {
    var id = _a.id, file = _a.file, destination = _a.destination, onStatusChange = _a.onStatusChange;
    var _b = (0, react_1.useState)(null), uploadingId = _b[0], setUploadingId = _b[1];
    var _c = (0, react_1.useState)(0), progress = _c[0], setProgress = _c[1];
    var _d = (0, react_1.useState)(null), status = _d[0], setStatus = _d[1];
    var onUpload = (0, react_1.useMemo)(function () { return function (id, currentStatus, currentProgress) {
        setProgress(currentProgress);
        if (currentStatus !== status) {
            setStatus(currentStatus);
            if (onStatusChange) {
                onStatusChange(currentStatus);
            }
        }
    }; }, [status, setStatus, setProgress]);
    (0, react_1.useEffect)(function () {
        if (id !== uploadingId) {
            setUploadingId(id);
            (0, FileUpload_1.FileUpload)(id, file, destination, onUpload);
        }
    }, [file, destination, onUpload, react_1.useMemo]);
    return (0, jsx_runtime_1.jsx)(Progress_1.Progress, { progress: progress }, void 0);
};
exports.InvisibleAttachment = InvisibleAttachment;
